export const APP_VERSION = import.meta.env.VITE_APP_VERSION?.trim() || '1.0'

export const APP_PRODUCT_LABEL = `Carearly v${APP_VERSION}`
